import { IReverseButton } from "@/shared/interfaces/ReUsedComponentsProps";

import "./AddFormulaButton.scss";

export default function AddFormulaButton({ onClick }: IReverseButton) {
    return (
        <button onClick={onClick} className='add_formula_button '>
            <img
                className='edit_drawer_plus_container'
                src='/scheduleTable/add.svg'
                alt='plus logo'
            />
            Додати зубну формулу
        </button>
    );
}
